import React from 'react';
import cx from 'classnames';
import s from './VerifiedMembersCard.module.scss';
import fonts from '../../styles/typography.module.scss';
import { InfoIcon } from '../../icons';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useSelector } from 'store/hooks';
import { RootState } from '../../store';
import { Link, useParams } from 'react-router-dom';
import useCommunityCredits from '../../hooks/useCommunityCredits';
import useRecommendedPlanByVerifiedMembers from '../../hooks/useRecommendedPlanByVerifiedMembers';

const VerifiedMembersCard = () => {
  const platform = useSelector(
    (state: RootState) => state.user.platform || 'discord',
  );
  const platformPrefix = platform === 'discord' ? 'DIS' : 'TEL';
  const { communityId: activeCommunityId } = useParams() as {
    communityId: string;
  };
  const { credits: communityCredits } = useCommunityCredits(
    platformPrefix,
    activeCommunityId,
  );
  const currentVerified = communityCredits?.currentVerifiedMembers ?? 0;
  const { recommendedPlanName } = useRecommendedPlanByVerifiedMembers(
    platform,
    currentVerified,
  );

  if (communityCredits?.currentVerifiedMembers === -1) {
    return null;
  }
  return (
    <div>
      <div className={cx(s.accessUnitsWrapper)}>
        <div className={cx(s.accessUnitsDetailRow1, fonts.caption1)}>
          <p className={s.labelWithIcon}>
            <span className={s.labelWithColor}>Pending Members:</span>{' '}
            <span
              data-tooltip-content={
                'Your community is growing! These members are awaiting verification to join your group. Grow your plan to let them in 🫶'
              }
              data-tooltip-id="tooltip-access-units"
            >
              <InfoIcon className={s.infoIcon} title="Info icon" />
            </span>
            <ReactTooltip
              id="tooltip-access-units"
              place="right"
              variant="dark"
            />
          </p>
          <p>{communityCredits?.pendingMembers ?? 0}</p>
        </div>
        <div className={cx(s.accessUnitsDetailRow1, fonts.caption1)}>
          <p className={s.labelWithIcon}>
            The Right Plan for You:{' '}
            <span
              data-tooltip-content={'Tailored to your community’s needs'}
              data-tooltip-id="tooltip-access-units"
            >
              <InfoIcon className={s.infoIcon} title="Info icon" />
            </span>
            <ReactTooltip
              id="tooltip-access-units"
              place="right"
              variant="dark"
            />
          </p>
          <p>
            <Link
              className={s.planLink}
              aria-label={`View ${recommendedPlanName} subscription plan`}
              to={`/dashboard/${activeCommunityId}/subscription`}
            >
              {recommendedPlanName}
            </Link>
          </p>
        </div>

        <div className={cx(s.accessUnitsDetailRow1, fonts.caption1)}>
          <p className={s.labelWithIcon}>Your Current Plan:</p>
          <p>{communityCredits?.planName ?? 'Free'}</p>
        </div>
      </div>
    </div>
  );
};

export default VerifiedMembersCard;
